
import { NgModule } from '@angular/core';

import { PriceTableComponent } from './price-table.component';
import { CommonModule } from '@angular/common';
import { MatTableModule } from '@angular/material/table';
import { PricePipesModule } from 'libraries/pipes/price/price-pipes.module';
import { SectorAirSummaryModule } from 'libraries/component/booking-information/components/sectors/components/sectors-air/sector-air-summary/sector-air-summary.module';
import { TableSectorAirSummaryModule } from '../table-sector-air-summary/table-sector-air-summary.module';
import { TableSectorStaySummaryModule } from '../table-sector-stay-summary/table-sector-stay-summary.module';
import { BtnModule } from 'libraries/ui_button/btn.module';
import { AdditionalInfosComponent } from './additional-infos.component';
import {FontAwesomeModule} from "@fortawesome/angular-fontawesome";
import { TravellerDataTranslationModule } from 'libraries/service/traveller-data-translation/traveller-data-translation.module';

@NgModule({
    imports: [
        CommonModule,
        MatTableModule,
        BtnModule,
        PricePipesModule,
        SectorAirSummaryModule,
        TableSectorAirSummaryModule,
        TableSectorStaySummaryModule,
        FontAwesomeModule,
        TravellerDataTranslationModule,
    ],
    declarations: [
        PriceTableComponent,
        AdditionalInfosComponent
    ],
    exports: [
        PriceTableComponent
    ],
})
export class PriceTableModule { }
